import { useState, useCallback } from 'react';
export var useValidationOnKeyUp = function (onKeyUp) {
    var _a = useState(true), isValid = _a[0], setIsValid = _a[1];
    var extendedOnKeyUp = useCallback(function (event) {
        setIsValid(event.target.validity.valid);
        onKeyUp === null || onKeyUp === void 0 ? void 0 : onKeyUp(event);
    }, [onKeyUp]);
    return [isValid, extendedOnKeyUp];
};
//# sourceMappingURL=useValidationOnKeyUp.js.map